import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _noop from 'lodash/noop';

import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton';
import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { mainCq } from '../../styles/helpers/main-cq';

export const Tag = styled.h2`
    font-family: ${({ theme }) => theme.fonts.family.primary};
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    ${({ enableLeftRightMargin, theme }) => enableLeftRightMargin
        ? css`
            margin: 0 ${theme?.pageTemplate?.paddingLeftRight?.xs} 20px;
            ${media.mdmin`
                margin: 0 ${theme?.pageTemplate?.paddingLeftRight?.md} 20px;
            `};
            ${media.lgmin`
                margin: 0 ${theme?.pageTemplate?.paddingLeftRight?.lg} 20px;
            `};
        `
        : `margin-bottom: 20px;`
}

    ${mainCq.md`
        font-size: 22px;
    `}
`;

// "body &" fixes an issue where basesite overrides color in the "a" tag
const A = styled(Link)`
    color: ${COLORS.mlbWhite};
    body & {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const Placeholder = styled(Skeleton)`
    min-width: 166px;
    height: 20px;

    ${mainCq.md`
        height: 22px;
    `}
`;

const RowHeading = ({
    enableLeftRightMargin,
    link,
    loading,
    onClick,
    size,
    text,
    ...otherProps
}) => {

    const title = link ? (
        <A
            to={link}
            onClick={onClick}
        >
            {text}
        </A>
    ) : text;

    return (
        <Tag size={size} enableLeftRightMargin={enableLeftRightMargin} {...otherProps}>
            {loading ? <Placeholder width={'30%'} margin={'0'} /> :  title}
        </Tag>
    );

};

RowHeading.propTypes = {
    enableLeftRightMargin: PropTypes.bool,
    link: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    text: PropTypes.string,
};

RowHeading.defaultProps = {
    enableLeftRightMargin: false,
    link: '',
    loading: false,
    onClick: _noop,
    text: '',
};

export default RowHeading;
